import { formatISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { calculateOddValueFromMatchAndBetArgs } from './calculateOddValueFromMatchAndBetArgs';
import { getBetValue } from './getBetValue';
import { getBetRequestId } from './getBetRequestId';
import { SportType } from '@supersports/services';

export const ServiceUtils = {
  getBetValue,
  convertDatetoUTC(date: Date) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatISO(zonedTimeToUtc(date, timeZone));
  },
  wait(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
  calculateOddValueFromMatchAndBetArgs,
  getBetRequestId,
  sortedAvailableMatchBySprotType(availableMatches: Record<SportType, any>) {
    let sortedMap = new Map<SportType, any>();
    Object.keys(SportType).forEach((key) => {
      const sportKey = key as SportType;
      const match = availableMatches[sportKey];
      if (match !== undefined) {
        sortedMap.set(sportKey, match);
      }
    });
    return sortedMap;
  },
};
